import { createPerStudyDb } from './createPerStudyDb';

// Constants for ECG Info Database
const ECG_DB_NAME = 'DB_WORKER_ECG_INFO';
const ECG_OBJECT_STORE_NAME = 'ECG_WORKER';
const ECG_OBJECT_STORE_KEY = 'key';

const ecgDb = createPerStudyDb({
  dbSuffix: ECG_DB_NAME,
  storeName: ECG_OBJECT_STORE_NAME,
  keyPath: ECG_OBJECT_STORE_KEY,
});

// Delete ECG database
/**
 * Drops the per-study ECG waveform database. Builds the name from the study id and the ECG database suffix, deletes it, and logs any failure instead of propagating it.
 *
 * @param studyId - Study whose ECG database is removed.
 * @returns A promise resolving once the ECG database has been deleted or the failure logged.
 */
const deleteDataFromDBECG = async (studyId: string) => {
  try {
    await ecgDb.removeDb(studyId);
  } catch (error) {
    console.error(`[${ECG_DB_NAME}] Failed to delete ECG database`, error);
  }
};

export { deleteDataFromDBECG };
